import { AxiosError } from 'axios';
import { BaseClient } from '../client';
import { IndicacaoApiResponse, IndicacaoRegraIndicador } from './indicacao.types';

export type IndicacaoRegraPayload = {
	tipo_regra: string;
	qtd_dias: number | null;
	qtd_vezes: number | null;
};

export const putIndicacaoRegra = async (idUsuario: number, payload: IndicacaoRegraPayload) => {
	try {
		const response = await BaseClient.put<IndicacaoApiResponse<IndicacaoRegraIndicador>>(
			`v2/Indicacao/Usuario/${idUsuario}/Regra`,
			payload
		);
		return response.data;
	} catch (error) {
		const axiosError = error as AxiosError<IndicacaoApiResponse<IndicacaoRegraIndicador>>;
		if (axiosError.response?.data?.message) {
			return axiosError.response.data;
		}
		throw error;
	}
};
